import { deleteRecord } from '@/entities/shared/record/delete-record';

export async function deleteShoppingItem(id: string): Promise<void> {
  await deleteRecord('shopping', id);
}
